import { render, staticRenderFns } from "./StepUpload.vue?vue&type=template&id=4955d311&scoped=true"
import script from "./StepUpload.vue?vue&type=script&lang=js"
export * from "./StepUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4955d311",
  null
  
)

export default component.exports